export default [
    {
        path: "/demo-grid-group-data",
        name: "demoGridGroupData",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoGridGroupData.vue"),
        meta: {}
      },
      {
        path: "/demo-grid-group-header",
        name: "demoGridGroupHeader",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoGridGroupHeader.vue"),
        meta: {}
      },
      {
        path: "/demo-control",
        name: "demoControl",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoControl.vue"),
        meta: {}
      },
      {
        path: "/demo-grid-layout",
        name: "demoGridLayout",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoGridLayout.vue"),
        meta: {}
      },
      {
        path: "/demo-grid-view",
        name: "demoGridViewLocal",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoGridViewLocal.vue"),
        meta: {}
      },
      {
        path: "/demo-grid-edit",
        name: "demoGridEdit",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoGridEdit.vue"),
        meta: {}
      },
      {
        path: "/demo-tree-list",
        name: "demoTreeList",
        component: () => import(
          /*webpackChunkName:'demo'*/
          "@/views/demo/DemoTreeList.vue"),
        meta: {}
      },
]